import { type AddressData } from "~/gql/graphqlBase.generated";

export type PostalAddress = Omit<AddressData, "__typename">;

const toLocationAddress = (address?: PostalAddress | null): AddressData | null =>
	address
		? {
				addressLine1: address.addressLine1,
				addressLine2: address.addressLine2,
				city: address.city,
				country: address.country,
				id: address.id,
				stateProvince: address.stateProvince,
				toName: address.toName,
				zipcode: address.zipcode
			}
		: null;

export default toLocationAddress;
